import React from "react";
import "../../Consultation/ConsultProcess/ConsultProcess.css";

const LocationCarRentalServe = () => {
  return (
    <div className="container consult-process-section mb-5">
      <div className="row px-xxl-5 px-md-3 px-2">
        <div className="col-md-12">
          <h1 className="text-center headings">
            <span>Avail Car Rental  </span> Services in 30+ Locations
          </h1> 

          <div className="row mt-md-5 mt-4">
            <div className="col-md-2 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">Angola</h3>
              
                <p className="text-center  process-txt">
                Luanda
                </p>
              </div>
            </div>
            <div className="col-md-2 mt-4 mt-md-0 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">Madagascar</h3>
                <p className="text-center  process-txt">
                Antananarivo
                </p>
              </div>
            </div>
            <div className="col-md-2   mt-4 mt-md-0 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">Zimbabwe</h3>
             
                <p className="text-center  process-txt">
                Harare
                </p>
              </div>
            </div>
            <div className="col-md-2   mt-4 mt-md-0 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">Zambia</h3>
             
                <p className="text-center  process-txt">
                Lusaka
                </p>
              </div>
            </div>
            <div className="col-md-2   mt-4 mt-md-0 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">C.A.R.</h3>
             
                <p className="text-center  process-txt">
                Bangui
                </p>
              </div>
            </div>
            <div className="col-md-2   mt-4 mt-md-0 ">
              <div className="process-box">
                <h3 className="headings text-center border-bottom">Kenya</h3>
             
                <p className="text-center  process-txt">
                Nairobi
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCarRentalServe;
